module.exports = __webpack_public_path__ + "static/media/nfts.7a65158a.jpg";